(function() {
    const tagsInput = document.querySelector('#tags_input')

    if(tagsInput) {

        const tagsDiv = document.querySelector('#tags');
        const tagsInputHidden = document.querySelector('[name="tags"]');

        let tags = [];

        //recuperar del input oculto

        if(tagsInputHidden.value !== '') {
            tags = tagsInputHidden.value.split(',');
            mostrarTags();
        }

        // Escuchar los cambios en el input
        tagsInput.addEventListener('keypress', guardarTag)

        function guardarTag(e) {
            
            if(e.keyCode === 44) {

                if(e.target.value.trim() === '' || e.target.value.length < 1) {
                    return
                }

                e.preventDefault();

                tags = [...tags, e.target.value.trim()]

                tagsInput.value = '';

                actualizarInputHidden(); // Se añade para que guarde al crear
                mostrarTags();
            }
        }

        function mostrarTags() {
            tagsDiv.textContent = '';

            tags.forEach(tag => {
                const etiqueta = document.createElement('LI');
                etiqueta.classList.add('formulario__tag')
                etiqueta.textContent = tag;
                etiqueta.ondblclick = elimitarTag
                tagsDiv.appendChild(etiqueta)
            })
        }

        function elimitarTag(e) {
            e.target.remove()

            tags = tags.filter(tag => tag !== e.target.textContent)
            actualizarInputHidden();
            mostrarTags();
        }

        function actualizarInputHidden() {
            tagsInputHidden.value = tags.toString();
        }
    }
}) ()